import React, { createContext, useContext, useCallback, useState, useEffect } from 'react';
import debounce from 'lodash/debounce';
const VideoPlayContext = createContext();

export const useVideoPlay = () => useContext(VideoPlayContext);

export const VideoPlayProvider = ({ children }) => {
    const [playingVideoId, setPlayingVideoId] = useState(null);
    const [videosInView, setVideosInView] = useState([]);

    const debouncedSetVideosInView = debounce(setPlayingVideoId, 150);
    useEffect(() => {
        if (videosInView.length > 0) {
            const [mostVisibleVideo] = videosInView;
            debouncedSetVideosInView(mostVisibleVideo.id);
        } else {
            debouncedSetVideosInView(null);
        }
    }, [videosInView, debouncedSetVideosInView]);

    const registerVideoInView = useCallback((id, intersectionRatio) => {
        setVideosInView(prevVideos => {
            const existingVideo = prevVideos.find(video => video.id === id);
            if (existingVideo && existingVideo.ratio === intersectionRatio) {
                return prevVideos;
            }
            return [
                ...prevVideos.filter(video => video.id !== id),
                { id, ratio: intersectionRatio }
            ].sort((a, b) => b.ratio - a.ratio);
        });
    }, []);
    
    const unregisterVideo = useCallback((id) => {
        setVideosInView(prevVideos => {
            if (!prevVideos.some(video => video.id === id)) {
                return prevVideos;
            }
            return prevVideos.filter(video => video.id !== id);
        });
    }, []);

    return (
        <VideoPlayContext.Provider value={{ playingVideoId, registerVideoInView, unregisterVideo }}>
            {children}
        </VideoPlayContext.Provider>
    );
};
